import React from 'react';

import { btn } from '@/styles/components/buttons.module.scss';

const BuyBtn = () => {
  return (
    <a
      href="https://fareharbor.com/embeds/book/tampabayboatingadventures/items/?full-items=yes"
      className={btn}
    >
      Book Online
    </a>
  );
};

export default BuyBtn;
